module.exports = __webpack_public_path__ + "static/img/title-yysj-new.aaba71ff.png";